import React, { FC, useState }         from "react";
import { useDispatch }                 from "react-redux";
import { Button, Header, Icon, Modal } from "semantic-ui-react";
import DeleteMailTemplate              from "../../../../../application/usecase/mail/template/DeleteMailTemplate";
import MailTemplate                    from "../../../../../domain/mail/template/MailTemplate";

interface Props {
  mailTemplate: MailTemplate;
}

const MailTemplateDeleteButton: FC<Props> = (props: Props) => {
  const {mailTemplate} = props;
  const [open, setOpen] = useState(false);
  const deleteMailTemplate: DeleteMailTemplate = new DeleteMailTemplate(useDispatch());

  return (
    <>
      <Button
        icon
        labelPosition="left"
        negative
        onClick={ () => setOpen(true) }
      >
        <Icon name="trash"/>
        削除する
      </Button>

      <Modal
        open={ open }
      >
        <Modal.Header>メール雛形削除の確認</Modal.Header>
        <Modal.Content>
          <Header as="h5" icon="info circle" dividing content={ `${ mailTemplate.name.value }を削除します。` } color="red"/>
          <Modal.Description>
            <p>よろしいですか？</p>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button
            onClick={ () => setOpen(false) }
          >
            閉じる
          </Button>

          <Button
            icon
            labelPosition="left"
            negative
            onClick={ () => {
              deleteMailTemplate.execute(mailTemplate.id);
              setOpen(false);
            } }
          >
            <Icon name="trash"/>
            削除する
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default MailTemplateDeleteButton;
